import React from 'react';
import { BondInsuranceForGetCompleteBondInsuranceProposalByIdResponseDTO } from '../../../../../dtos/bond-insurance-proposal-list/get-complete-bond-insurance-proposal-by-id-response.dto';
import { DateToStringDate } from '../../../../../services/date';
import { maskMoney } from '../../../../../services/masks';

export type Props = {
  bondInsurance: BondInsuranceForGetCompleteBondInsuranceProposalByIdResponseDTO;
};

const FieldDisplay = ({ label, value }: { label: string; value: React.ReactNode }) => (
  <div style={{ paddingBottom: '16px' }}>
    <div
      style={{
        fontWeight: 'bold',
        marginBottom: '0.35em',
        color: '#555',
        fontSize: '0.85em',
        textTransform: 'uppercase'
      }}
    >
      {label}
    </div>
    <div style={{ fontSize: '0.95em', wordBreak: 'break-word' }}>
      {value || 'Indisponível'}
    </div>
  </div>
);

export const BondInsurancePropertyDetails = (props: Props) => {
  const { property, purpose } = props.bondInsurance;

  return (
    <div className="row" style={{ paddingLeft: '8px', paddingRight: '8px' }}>
      {property.readjustment_index &&
        property.rent_insurance_contract_end_date &&
        property.rent_insurance_contract_start_date && (
          <>
            <div style={{ display: 'flex', width: '100%' }}>
              <div style={{ flex: 1, boxSizing: 'border-box', paddingRight: '10px' }}>
                <FieldDisplay
                  label="INÍCIO DO CONTRATO DO SEGURO"
                  value={
                    property.rent_insurance_contract_start_date
                      ? DateToStringDate(property.rent_insurance_contract_start_date)
                      : 'Indisponível'
                  }
                />
              </div>
              <div style={{ flex: 1, boxSizing: 'border-box' }}>
                <FieldDisplay
                  label="FIM DO CONTRATO DO SEGURO"
                  value={
                    property.rent_insurance_contract_end_date
                      ? DateToStringDate(property.rent_insurance_contract_end_date)
                      : 'Indisponível'
                  }
                />
              </div>
            </div>
            <div style={{ display: 'flex', width: '100%' }}>
              <div style={{ flex: 1, boxSizing: 'border-box' }}>
                <FieldDisplay
                  label="ÍNDICE DE REAJUSTE"
                  value={property.readjustment_index}
                />
              </div>
            </div>
          </>
        )}

      {property.rental_period_start_date &&
        property.rental_period_end_date &&
        property.rental_periodicity && (
          <>
            <div style={{ display: 'flex', width: '100%' }}>
              <div style={{ flex: 1, boxSizing: 'border-box', paddingRight: '10px' }}>
                <FieldDisplay
                  label="INÍCIO DO CONTRATO DE LOCAÇÃO"
                  value={
                    property.rental_period_start_date
                      ? DateToStringDate(property.rental_period_start_date)
                      : 'Indisponível'
                  }
                />
              </div>
              <div style={{ flex: 1, boxSizing: 'border-box' }}>
                <FieldDisplay
                  label="FIM DO CONTRATO DE LOCAÇÃO"
                  value={
                    property.rental_period_end_date
                      ? DateToStringDate(property.rental_period_end_date)
                      : 'Indisponível'
                  }
                />
              </div>
            </div>
            <div style={{ display: 'flex', width: '100%' }}>
              <div style={{ flex: 1, boxSizing: 'border-box' }}>
                <FieldDisplay
                  label="PERIODICIDADE DE LOCAÇÃO"
                  value={property.rental_periodicity}
                />
              </div>
            </div>
          </>
        )}

      <div style={{ display: 'flex', width: '100%' }}>
        <div style={{ flex: 1, boxSizing: 'border-box' }}>
          <FieldDisplay
            label="DIA DE VENCIMENTO DO ALUGUEL"
            value={`${property.rent_due_date || 'Indisponível'}`}
          />
        </div>
      </div>

      <div style={{ display: 'flex', width: '100%' }}>
        <div style={{ flex: 1, boxSizing: 'border-box', paddingRight: '10px' }}>
          <FieldDisplay label="LOGRADOURO" value={property.street} />
        </div>
        <div style={{ flex: 1, boxSizing: 'border-box' }}>
          <FieldDisplay label="NÚMERO" value={property.number} />
        </div>
      </div>

      <div style={{ display: 'flex', width: '100%' }}>
        <div style={{ flex: 1, boxSizing: 'border-box', paddingRight: '10px' }}>
          <FieldDisplay label="COMPLEMENTO" value={property.complement} />
        </div>
        <div style={{ flex: 1, boxSizing: 'border-box' }}>
          <FieldDisplay label="BAIRRO" value={property.district} />
        </div>
      </div>

      <div style={{ display: 'flex', width: '100%' }}>
        <div style={{ flex: 1, boxSizing: 'border-box', paddingRight: '10px' }}>
          <FieldDisplay label="CIDADE" value={property.city} />
        </div>
        <div style={{ flex: 1, boxSizing: 'border-box' }}>
          <FieldDisplay label="ESTADO" value={property.state} />
        </div>
      </div>

      <div style={{ display: 'flex', width: '100%' }}>
        <div style={{ flex: 1, boxSizing: 'border-box', paddingRight: '10px' }}>
          <FieldDisplay label="CEP" value={property.zip_code} />
        </div>
        <div style={{ flex: 1, boxSizing: 'border-box' }}>
          <FieldDisplay
            label="TIPO DE LOCAÇÃO"
            value={purpose === 'RESIDENTIAL' ? 'Residencial' : 'Comercial'}
          />
        </div>
      </div>

      {property.property_type && (
        <div style={{ display: 'flex', width: '100%' }}>
          <div style={{ flex: 1, boxSizing: 'border-box' }}>
            <FieldDisplay label="TIPO DE IMÓVEL" value={property.property_type} />
          </div>
        </div>
      )}

      <div style={{ display: 'flex', width: '100%' }}>
        <div style={{ flex: 1, boxSizing: 'border-box', paddingRight: '10px' }}>
          <FieldDisplay
            label="ALUGUEL (R$)"
            value={maskMoney(`${property.rent_value || 0}`, true)}
          />
        </div>
        <div style={{ flex: 1, boxSizing: 'border-box' }}>
          <FieldDisplay
            label="CONDOMÍNIO (R$)"
            value={maskMoney(`${property.condominium_fee || 0}`, true)}
          />
        </div>
      </div>
      {property.rent_indemnity_period && (
        <div style={{ display: 'flex', width: '100%' }}>
          <div style={{ flex: 1, boxSizing: 'border-box' }}>
            <FieldDisplay
              label="PERIODO INDENITÁRIO ALUGUEL"
              value={
                property.rent_indemnity_period
                  ? `${property.rent_indemnity_period} meses`
                  : 'Indisponível'
              }
            />
          </div>
        </div>
      )}

      <div style={{ display: 'flex', width: '100%' }}>
        <div style={{ flex: 1, boxSizing: 'border-box', paddingRight: '10px' }}>
          <FieldDisplay
            label="IPTU (R$)"
            value={maskMoney(`${property.taxes_value || 0}`, true)}
          />
        </div>
        <div style={{ flex: 1, boxSizing: 'border-box' }}>
          <FieldDisplay
            label="ENERGIA (R$)"
            value={maskMoney(`${property.energy_bill || 0}`, true)}
          />
        </div>
      </div>

      <div style={{ display: 'flex', width: '100%' }}>
        <div style={{ flex: 1, boxSizing: 'border-box', paddingRight: '10px' }}>
          <FieldDisplay
            label="ÁGUA (R$)"
            value={maskMoney(`${property.water_bill || 0}`, true)}
          />
        </div>
        <div style={{ flex: 1, boxSizing: 'border-box' }}>
          <FieldDisplay
            label="GÁS CANALIZADO (R$)"
            value={maskMoney(`${property.gas_bill || 0}`, true)}
          />
        </div>
      </div>

      <div style={{ display: 'flex', width: '100%' }}>
        <div style={{ flex: 1, boxSizing: 'border-box', paddingRight: '10px' }}>
          <FieldDisplay
            label="MULTAS CONTRATUAIS (R$)"
            value={maskMoney(`${property.contract_penalties_value || 0}`, true)}
          />
        </div>
        <div style={{ flex: 1, boxSizing: 'border-box' }}>
          <FieldDisplay
            label="PINTURA INTERNA (R$)"
            value={maskMoney(`${property.interior_painting_value || 0}`, true)}
          />
        </div>
      </div>

      <div style={{ display: 'flex', width: '100%' }}>
        <div style={{ flex: 1, boxSizing: 'border-box', paddingRight: '10px' }}>
          <FieldDisplay
            label="PINTURA EXTERNA (R$)"
            value={maskMoney(`${property.exterior_painting_value || 0}`, true)}
          />
        </div>
        <div style={{ flex: 1, boxSizing: 'border-box' }}>
          <FieldDisplay
            label="DANOS A MÓVEIS (R$)"
            value={maskMoney(`${property.furniture_damage_value || 0}`, true)}
          />
        </div>
      </div>

      <div style={{ display: 'flex', width: '100%' }}>
        <div style={{ flex: 1, boxSizing: 'border-box' }}>
          <FieldDisplay
            label="DANOS AO IMÓVEL (R$)"
            value={maskMoney(`${property.property_damage_value || 0}`, true)}
          />
        </div>
      </div>
    </div>
  );
};
